webpackJsonp([15],{

/***/ 408:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 504:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 505:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _showdown = __webpack_require__(71);

var _showdown2 = _interopRequireDefault(_showdown);

var _reactLazyload = __webpack_require__(70);

var _reactLazyload2 = _interopRequireDefault(_reactLazyload);

var _inIcon = __webpack_require__(564);

var _inIcon2 = _interopRequireDefault(_inIcon);

var _twIcon = __webpack_require__(408);

var _twIcon2 = _interopRequireDefault(_twIcon);

var _close = __webpack_require__(505);

var _close2 = _interopRequireDefault(_close);

__webpack_require__(565);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var converter = new _showdown2.default.Converter();

var TeamMemberPopup = function TeamMemberPopup(props) {
  return _react2.default.createElement(
    'div',
    { className: 'popup' },
    _react2.default.createElement('img', { className: 'closeIcon', src: _close2.default, alt: '', onClick: props.closePopup, onKeyDown: props.closePopup }),
    _react2.default.createElement(
      'div',
      { className: 'col-custom-image' },
      _react2.default.createElement('div', {
        className: 'popup__image',
        style: {
          backgroundImage: 'url(//img2.storyblok.com/fit-in/300x300' + props.src.replace('//a.storyblok.com', '') + ')'
        }
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'col-custom-text sm:overflow-auto' },
      _react2.default.createElement(
        'div',
        { className: 'popup__name' },
        props.name
      ),
      _react2.default.createElement(
        'div',
        { className: 'staff__title popup__title' },
        props.title
      ),
      _react2.default.createElement('div', {
        className: 'rich-text popup__bio',
        dangerouslySetInnerHTML: {
          __html: converter.makeHtml(props.bio)
        }
      })
    )
  );
};

// class TeamMemberPopup extends React.Component {
//   constructor(props) {
//     super(props)
//     this.modalCover = React.createRef()
//     this.escFunction = this.escFunction.bind(this)
//   }
//   escFunction = event => {
//     if (event.keyCode === 27) {
//       this.close()
//     }
//   }

//   render() {
//     return (
//       <div
//         className={`z-20  transition-all duration-300 fixed bg-black top-0 bottom-0 left-0 right-0 ${
//           this.props.show ? 'visible opacity-100 pointer-events-auto' : 'opacity-0 invisible'
//         } flex items-center justify-center`}
//         onClick={e => {
//           e.target === this.modalCover.current ? this.props.closePopup() : null
//         }}
//         style={{ overScrollBehavior: 'none', backgroundColor: 'rgba(0,0,0,0.7) ' }}
//         ref={this.modalCover}
//       >
//         <div className='relative m-4 overflow-auto bg-white rounded-lg md:max-w-2xl lg:max-w-5xl lg:w-full'>
//           <div className='flex flex-col px-8 py-6 pointer-events-auto'>
//             <img
//               className='closeIcon'
//               src={close}
//               alt=''
//               onClick={this.props.closePopup}
//               onKeyDown={this.props.closePopup}
//             />
//             <div className='col-custom-image'>
//               <div
//                 className='popup__image'
//                 style={{
//                   backgroundImage: `url(//img2.storyblok.com/fit-in/300x300${this.props.src.replace(
//                     '//a.storyblok.com',
//                     ''
//                   )})`,
//                 }}
//               />
//             </div>
//             <div className='text-left col-custom-text'>
//               <div className='popup__name'>{this.props.name}</div>
//               <div className='staff__title popup__title'>{this.props.title}</div>
//               <div
//                 className='rich-text popup__bio'
//                 dangerouslySetInnerHTML={{
//                   __html: converter.makeHtml(this.props.bio),
//                 }}
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//     )
//   }
// }

var StaffMember = function (_React$Component) {
  _inherits(StaffMember, _React$Component);

  function StaffMember(props) {
    _classCallCheck(this, StaffMember);

    var _this = _possibleConstructorReturn(this, (StaffMember.__proto__ || Object.getPrototypeOf(StaffMember)).call(this, props));

    _this.openPopup = function () {
      _this.setState({ isPopupOpen: true });
    };

    _this.closePopup = function () {
      _this.setState({ isPopupOpen: false });
    };

    _this.state = {
      isPopupOpen: false
    };
    return _this;
  }

  _createClass(StaffMember, [{
    key: 'render',
    value: function render() {
      var isPopupOpen = this.state.isPopupOpen;

      return _react2.default.createElement(
        'div',
        { className: 'staff' },
        isPopupOpen && _react2.default.createElement(TeamMemberPopup, {
          name: this.props.name,
          closePopup: this.closePopup,
          title: this.props.title,
          bio: this.props.bio,
          src: this.props.src
        }),
        _react2.default.createElement(
          _reactLazyload2.default,
          { height: '200' },
          _react2.default.createElement('div', {
            className: 'staff__image',
            style: {
              backgroundImage: 'url(//img2.storyblok.com/fit-in/300x300' + this.props.src.replace('//a.storyblok.com', '') + ')'
            },
            onClick: this.openPopup
          }),
          _react2.default.createElement(
            'div',
            { className: 'staff__name' },
            this.props.name
          ),
          _react2.default.createElement(
            'div',
            { className: 'staff__title' },
            this.props.title
          ),
          this.props.linkedIn && _react2.default.createElement(
            'a',
            { href: this.props.linkedIn, target: '_blank', rel: 'noopener noreferrer' },
            _react2.default.createElement('img', { className: 'staff__icon inIcon-border', src: _inIcon2.default, alt: '' })
          ),
          this.props.twitter && _react2.default.createElement(
            'a',
            { href: this.props.twitter, target: '_blank', rel: 'noopener noreferrer' },
            _react2.default.createElement('img', { className: 'staff__icon twIcon-border', src: _twIcon2.default, alt: '' })
          )
        )
      );
    }
  }]);

  return StaffMember;
}(_react2.default.Component);

exports.default = StaffMember;

/***/ }),

/***/ 564:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAYAAAFOYwZEAAAABGdBTUEAALGPC/xhBQAAFSJJREFUeAHtXQmQHUUZ7n2b3WxIViAHOYAYCGCFS5QzxKQ2EQMkXLGCRQS0kBgtpbAsKbBADsWjVMoqSi0lIJYc8QhnOEQCxAqGgAlGk0gEjIEkJARykSV3dtfv6zfdO0fPvJ43M+/N231d1a97uv/+r6+7Z6Znpp8QEaGrq2s54qIwkgZ/BYi7/GXu4wYEdawzLCjVUDdyGOjGtg3dDGTjuA0Vg4LKuNOG774gGEsFY2Ox40MxtGOvZHCgsyuUUQEqLw9IaG4SjYhi2w5x83NviqcvO8nIoA8atgca920ShWZUIf3R5OMC1aqgAK+PUwc6bSiIQhMbN+sisX1Hd97Jpe/tgAhzwdLknUQxtu0sqn97cFaFipkhXWpBIwfJTdBkL+J0AxNZpG3mEQgHItkiaww/fqm6sa294LkLTPqTt7QZDTsNgsKKDgL9VFaW3UloAgdGYNqxGY5oNo8DIxgwmhjcTLpuneSnu9CDs67FaJJhy3ZhaKTJQho7o0kx0eTejLlxY2ORSg1JzCym0GBymInQUHZpMqgcjncYOIcW+bsp+/VmmmARzlJcdd9WBWys8v40INFPYDoGv9MtNNIkJh7WZeDSqTkly/zUJDSWu0wMYpRtgbsHK3otGEZFTl6qQdJUYS1HFISeDoahMyaFTb1/mZwYptz/j0SyiRoZlD2gEklH4z5Q4CYbJg3XPylEZ6cY3tpXbLj1XM+06G8fNeMpWs65t6iDyJRXNrgkKjBlaMeEhuOun11cPMave47WhSEZYnx5SJ23uAkCMYtqwZxRlRKKctsHKlcy7YNe9pCDd0liEjQUnIHQDMFwvSdQkfadnqKwA/dwCp3uwhqXW84hpQWTierq5TK0aadkes6MTuEuGwZl0IxVQiPbwvqp9EDSECnEphIKzLNUYroNv9g0EH4S4jOIPIGvQbwPsSU2I5sGYLwN0Tb82oZnJA0kJTknz45i7hlOihACOZXuV8dJ0rCe7BlOFACh5yNJRajDzzgxeSyG0DEgfo0N0g5+y/2CjdqlpYRbuHY1rM1UKJWHiM3KCCkYBcS1EmGQEiJdbWOtOsnbXF0o5mEpXa5dHUaUVTlvvTaC+bCsBJj40mLre76Gbz5WvMa6c5qYNuef4rE3t4rfTxsjrnh8lehwLkTunDxaXDv2oyZZ/rK37F3dB3evjAjNnR0ynfFot1AWfOPZ1bLc4meUvWDeNjcWyZv7IN1avLBjZ3N3uBuffcNCLmywoiIRBTtXSgVe8NF6wxLa4neCS3cmGfaCaWVncaIrFJCn9Z55z8Q+vAytLUOh29XSYul6lKlA67duV0clU3uLycoZ9trVjgekFAeK3e27SwoFwcO0eI4NpZsGo7CIOYWpQNfjuKGxtP/RfrqkspkyFf80Us4f9hinIbHI4zkm2i+VsprWUnClLZ5JoQzaYh5kbbWyNiA4S+FuoUbBWQj3C6UMI8YmQhKXEbi25YFT8TAKZqXTQC9cqga2Kdsj6AU1fzujNn4idLq+KNvjLzcc74cwZ83aUJt1ERS9GnEjR0mC8CDahnosaxtC+UOp8xMYFbfpolBFLCusupafF7RciLLx/vIqHI9EV14XR661wTAys/vXOAqH0K6D4SND6jzFJQ2GobyLfNrTKr8HB2C4s7RsVjLUYBjKi8/UlkHM4jMrXQzDzzZxNxqcozFq0jlOGd9l8CyuBAyGsbzNDZTHkZIz2rNg9CtKJ8+VB4ylNxIb+8i/N4kZc1eI+5dtUHKqmb4Ms9qUAto4FG5D4SGqotxUrUa527sXCtzlFc63AOm9EmEYezWEJzaWBvxrFp+KFgMvZ7fdMEEdVjuVl6gSYRjsGdjV0GwvVsjmrXpPrN2+R3xyRKuYeLRe60xTnWu4mncSOC5Pi2vDdU/wVlPHYQe3iI23nSfZX/nQCvHAv9/Xor508mHi3uXv6WNT5qnLThRTPnaYqaqsMnbpWC+NlJQi113A1lmBanCtyXTsO+BZhVLG3jZ+pDhwyySx6KpPBNhP/cNK8b+tVotHgbamAhp8qqmi7DK1vOqkDc6KJ/n14eITHcDlNz7WxhIcJ7RbJx0jWHX2yEM9K6FKh28987rKJk55NcVlzvQGDA1ydWm3wXrt0VVvY8H2vcV1aRvaUjRE+MVSRLHqna5s6tJ6zdPdC0zMnbVvU1XSMho8KymTQHuej+QSdqMouLq0XtaWTnHGeaAxCthGdnuuPH8gdn5g92KFiZWvrJNvfeyp1FlJI4z3Y0QXnBJ2NmQP0N0evnM5zWdA3MMTIZW85VJK9/kiLpvaoJfrXuzSXLHjo9TI5/e1YVO4lrBRLvJJhBUZkOaakfE+UtHUYgpjtZ0SYWUEyschf7c67gmp21jaoy13Gwekj8TxWndZDeY9b5oq/T0Iq0J4hYtidMY6VVZj6RFQ37imbTRYGYdGXAal4bgIrokwg/oivBOmrbFLhxGjq7+EurFh9VUsJ6KhRrr1ikTYTcg8mJ5N9yHLdpHvPpM+4zCTujjBytjU9AHybYhZh/mpKZwVI3jg64hrYniiA7R8wZlPOTIJscZwORpAeb6HegHiRYijEUc4kbelXNZk5B3bPHTPFUhrK8DAwYh81Jkk8FHr1bm2HAr+OomFEW35QnH3Umi1vQBlFkUom3YVH+xVJ8CS2WlbY8mPb3QPLNfq2JMWhOXlOvtFTHKxV/ljXXjAWH57trZc76bcbjz0Idqx3im0RhiMaSjRzWM4HmivslHMCmEYy1W0vBpLO1+DjlYTWkmEwYhvAcTqNtSgSmEKkP5zlOxIg2Es17rSW6SP0iS9usjuHdqlYSxvBWvNWLqN3Tu0RxoNRoOpaJjH+14aZBP2hREFujSMZRnf86j1YDxPmwyuxXEbBs4gTGJb3ZWeLg10z0RlLY5bt03uPMHzBI/BqHnZU1v7B3zDwXN+1l0aFW2wb0FSG/myyLf/8rp8FvaDyceJJvXJdVLGCdqjW2s7dQYGU9dEgQwKvh2KcvLK0hmweQmNk10atvLN88ThJwvXBHgsepuvf1U9PKs0UGN4ripIkh476KBA8xOHtgbKqlCg30FTBl+YhhKfPWGoOGvEAM3qyhOGiINbQi96NF0lMujFco1MjuE0xm8llE4o412M4+HcU+TrCRml0vxvGOuvvrNDDOzXJD538jDRN73XHJR+8htenqc404xSpUnSeas2iYvvxqlcv5+BvU7u/Kxm6X/xlDP4DxasFt9Z+LamUZl+TQWx68Y2dZhKytMTx/CoVLiBiRwfPOXpqKYIs4Rrn/qP0VhS797fGWszGLMEbynAPSlaIy99ySM4ECc6sNRRuiC03c+X8qFDdLjrlbXRBPFqL0rVYCmbV1bu6FaIL5xhpzR34FB97Wtnil03tYmxeIvWH776zH/9RUmOJ2RgMFgSYdmtfeyVI1yfOR+4eZIYM6S/6Ifvsl/6cuYPGIb7NEriPN8Ylt3a16VVV+fUAbS516U/fHrUwf6iNI9HpGqw1EyhKFMfezWZOTSnHBl8gPDxw7ovXNK01OHVmuplEO2R3ZmnJb5eKBhdgYaqYiys6M2rXCQWn7e7qGNnN6RqsBQvrUaO4Prs1c5wHCJn9dg6J2qwwdfnEjErNrbp0nQK6JRv3FJ378EyuG8md9cnzK9OH2FefkhLVN91qai7NLs2NuU1WSydARx4CuNbtR9JdUzLrUm5Qpk+0lTcbxBnaXXZCakmg9FKoi+HQ0eH/EzA5bKk2Sdp6KNJuVi3V05wUPT7g3ykE9x0Ke6CAd57aPDN1gonJZTjGyKdc7QRYUKsztcOXVKx7vZ8I34VLqrdZdnliRY/9qS4sC4t0ecYB42K6Wg0h2zkkIHBfDTRlA7f3HIZAnA3s0szfL6Y9NxfGkvrpME4eKjnmiotu0vZJ7s0D9Ct+S7jOaqiJ6UAVNupMzQQRnOa6GnhJdg7ThnlN5ir86epyp6QutGlPWrSkrahMvM78Ao78W6/PI/BTuVMP1GtHgPAWX7dPV1aVWIocwqv9efExm1rTAjzetb4RYhySA2kd8CGdSY9jQiTECgfjmS9qVHOyyL35TEiTIPgIX44UWtv8vCfREZGARJqsGM0X4GYEcUgR3XceKh/KX1Cu7S7Ibr3WThe7C7LWd742Z1Jx0iEVQN4jkgfoY5zlnJnJetJ1spgGgim7yCyR1T7Ay23vy+ASme7C0rlrQ1WjCCA3qz2xQmdzq2jnlJ62aZWYziMGcZ2Na69PdtFhemWaTkMn4+YdWjL1IhymMPi6Yj7UrScf/mQyitV5dgTqw0UHYP4MCK/J7QNa0CY6TsnicZwLA+kSAyn8GPMSYgTEU9F5NVV7AkYbaIC1lXlFzyvIl2A+AImSasPSaKYVroutwADRA7dCxG/gHgeYt5WkfdDp2cQ70N8AuAHH+6joh4cDwDQNsRKnNwgJtNAG9ryAmzVRjCcwG8NfoF4Wl6ckZEeS8H3GozwVzLiH8m2YgADUMr6EuKPEWt9cTDSqRGVvOG5AfFeAF6RBx6ZAwxgp8Kg3yH2VlBhujEQ7C8C6Nh3t0ZuIYWZAAxQubg7F7HW1jtD3JR5MVcKLwXYqW+ukyrAAJbLmk8i1kdreX2Co5oLdFwtTSWkcu8IYC9D5G0De2Id3PKhoe8W05f0aflsulsmGsFQgiP2ecTgl2jdMuq58j3A/7H9dJIRXRbAAJbnWI7WI8vXvd4yhgf4hJt/Lhz7HB17iga4P4UwPh2vgxsDoYSk9PV6x/exWFmPYDCnkGWI9XNsLBenTswLsU9gNBvfW/FLsxrBAPdqNFyLWAfX78HKHxODtQ4mJaWXBBiMZoPLPSU51Qkq7YF7HGwi5UZO0WCwBK17+lpxpINqoHIppuvQt4BDRzDAXVQHtwbgxQAEVn8L09Q4gtFgPhqcE9aokuWbPtwnrnxkpZi/xvvlPHU4fvBB4okZHxdHD+xXSZXyKus5jOTP+JULAAxw7wJR4L1xf8NKHD+/erM454HlJUW9d92nxJD+zSXpegHBbID8Fbednika4E5HZS7ApZJL1re7dQ3Nr0nx/8RChdRGxSwHQ62tBhgVg1E6R9fkIPONcR8VYwZFT7+zThkmzjgy020vcuCJWCrMcbCUjfQUjcIHUZLLD0r5ZPzv67bLf/7bsnufOLy1RZwwdIA4bnD/WJb3IuI5mKovp70SYIA7BvnXepEDeoOpcr/lPo6l38+jxUvWbxffm/+mVg0dsZhHwlz/AS1iUL8+4lcXHa9pVOb2F1aLFe/vVIeB9LaJR4vjXRv8LNuwQ8xeul78cdVmsW2P+W+VWvs2imnHDhS3TBwtRg/M/QO022H0dG7214LMJQEP5KDg3fa94smVG4uaaHAVyEWUhx3Szwjwys07xdz/yM/7jZac4kzxl8z5p3hq9TYjjb+wHX8det/K92Vk3Y8nHiWun3CUnywvx9OILS+yLkDUF1t50U7rwT1N1BYeMoWqKpX7nejLCN2EmZYS21H9cPFa0XT7AmtwPcydgxsWrBGj71wkdu7vMFVXu0xiyx/+21EuAy4U0PWgot64Jgi2pDFov3/v/sjNqHbu44cLwXAQds2U/4YcrDKW/G/7XjHxt68a63JQeBHPwcfkQJFwFQgyI6dolfLakMecrVlmCPgYr9g5+HfVpCP9IL3TsG7RhJH+/BWniPGjDtVlKsOROeX+ZWLhuh2qyJgu2fihmLvyXXHpicOM9VUsPIYjeHgVFSgtWk/RUFWBplLUNXCEG4LcRFC3dYGtNgzdUjzvbvrWeCO4ZNm/qVEsuOo0cURr6VWyp98IP98b1KtUkdyrc0SlpMWVI8emnqIdkBS4OjVzJbbeDoEC2cbhA77jBjeLQ3EVHhXIp21k6YWUdbggzGEYQeu4HpjPB/kKJAIjp2hoKj+Q4PTMSuyNKJFENhBQL0e3Q+ue4otNRWvf0iOTbIcPKE3XYT6lB7SqcEE7Ad6AmEuAiYMEyQCOXKIByKFTNBsTfJ5/JaDyR3cMdpDwzkHBPSLIrVgJcH4DQdLTtP88jDqObkMo6HZoo9qrKZq7K6I+pGmA265st4cNyEuxQAL8YooMM2DlgOiAosEiaEAobBSipvucK4FVQBfBlW0tEZZdiB2GF2jc3Dy7vYDT9t+LsFbMS5trdvwMYIeAJIsJiuoYEmSnvRzRBWCMY4sg6XR7p4PUBtjzuHfLCtj4loWdOSMpghUKkgSke7TK87EPbEt8i1O50yk8iy5q6gfYu3bwI4RchbeILUcwwx3FpOf8ekadGxzXSAztHD43SDo5G6BT6RSuc3WisFOFj1UlDyWmEmAY8EtIfreS0rOWJUenaYr2g22hSLCzqKlepfbTvYW4NEj4t1HEVN5ASIZ48sCX23P1/vN+/O3FjpBHd1Jp/DQCxEMMf0DGZcY9+HOiqNCMf35pbW6MIpF1u8Bnd8QDBT7G5JLnwS1NJXlViGAmAP4NZaELdgcoyguuC7tL6rka9AB3/NEPkPwA94VBnKqDq/I1aGkvVBn3cGIYANbrpuoiS/rCqZjcCx3TU0ye7AaXRnkAZgEI+LnKRObroaY8MNHBzqN0AGDWgvCvSKYwXw814YEpDmYBZT3nYH8tLrq4WdlixEg6f7v6ccU8wEcp/PL/lTCJJYEDyAPR+A3EXD5xCjOsF5TzQ/DjAO7WKFuNU7S7gcNgCMpy/lDCrXWPzxML/gVWJLj0QkmASQRGXYgTkOUbmJwW6qE6HqDvuY/WBGJio0LJKdrPBFM2XxJYiDjWX1c/ztQDvBYisOa38kNExwZY8QHQ/NyFU0X93Kyckk3Kc+14AFvWZuRWU7RJbwpE5BeJvJ2K1atM/OplAQ/Qp7z9GVwuuORYNsBKHQj/MyJX2Ql07h6KKj1rKKUPCWwTfZtU77Kn6DDBztT9F9RzX616sPfAOpCeC1DLmorDxCQewX7GVBBxJMo5qvnQ2epqz8+nlxzTN/QRR+vItMGlD1MfwWTqDxjVHM38wHy8v66XHvPi9HIAylGbaUh9BJu0pSGIvMRnh+JV992IvWlk01baPIg+QKAvMgcX8qofMLrPR1yE2NMCbTq/2h6uyBQdx0g45XTQz0T8HGKtvHjAB+1/QrwHI5OPW3MTcgewyTMAnffbFyNOcmK1vtPk2y4vOPFxgLkZ+VyHmgC4lAfRAbgNxbGIH3PFoci3Ig5wUuYZGdpd8UMnvwnp6674JgDcg+OaDv8HM0xq7McUkygAAAAASUVORK5CYII="

/***/ }),

/***/ 565:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/logo_fp_transparent.9646b0d2.png";

/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__(18);

var _reactStatic = __webpack_require__(12);

var _showdown = __webpack_require__(71);

var _showdown2 = _interopRequireDefault(_showdown);

var _storyblokReact = __webpack_require__(31);

var _storyblokReact2 = _interopRequireDefault(_storyblokReact);

__webpack_require__(504);

var _StaffMember = __webpack_require__(563);

var _StaffMember2 = _interopRequireDefault(_StaffMember);

var _logo_fp_transparent = __webpack_require__(566);

var _logo_fp_transparent2 = _interopRequireDefault(_logo_fp_transparent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var converter = new _showdown2.default.Converter();

var About = function About(props) {
  var content = props.story.content;


  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _reactHelmet.Helmet,
      null,
      _react2.default.createElement(
        'title',
        null,
        content && content.top[0].title
      )
    ),
    content && content.top.map(function (el) {
      return _react2.default.createElement(
        _storyblokReact2.default,
        { key: el._uid, content: el },
        _react2.default.createElement(
          'div',
          {
            className: 'hero hero--small',
            style: {
              backgroundImage: 'url(' + el.image + ')',
              backgroundPosition: 'center ' + (el.image_offset ? el.image_offset + '%' : '50%')
            }
          },
          _react2.default.createElement('div', { className: 'hero__overlay' }),
          _react2.default.createElement(
            'div',
            { className: 'wrapper' },
            _react2.default.createElement(
              'h1',
              { className: 'hero__title hero--small__title' },
              el.title
            )
          )
        )
      );
    }),
    _react2.default.createElement(
      'div',
      { className: 'wrapper' },
      _react2.default.createElement(
        'div',
        { className: 'about__intro' },
        content.intro.map(function (el) {
          return _react2.default.createElement(
            _storyblokReact2.default,
            { key: el._uid, content: el },
            el.component === 'Lead Paragraph' ? _react2.default.createElement(
              'div',
              { className: 'col-2-3 offset-2' },
              _react2.default.createElement(
                'p',
                { className: 'paragraph--lead' },
                el.text
              )
            ) : _react2.default.createElement(
              'div',
              { className: 'col-2-3 offset-2' },
              _react2.default.createElement(
                'p',
                { className: 'paragraph--sans' },
                el.text
              )
            )
          );
        })
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'background--gray' },
      _react2.default.createElement(
        'div',
        { className: 'wrapper' },
        _react2.default.createElement(
          'div',
          { className: 'team__intro' },
          content.team_intro.map(function (el) {
            return _react2.default.createElement(
              _storyblokReact2.default,
              { key: el._uid, content: el },
              el.component === 'Section Title' ? _react2.default.createElement(
                'p',
                { className: 'heading--small' },
                el.text
              ) : _react2.default.createElement(
                'p',
                { className: 'paragraph--sans' },
                el.text
              )
            );
          })
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'wrapper wrapper--flex staff__container ' },
        content.team.map(function (el) {
          return _react2.default.createElement(
            _storyblokReact2.default,
            { key: el._uid, content: el },
            _react2.default.createElement(_StaffMember2.default, {
              src: el.picture,
              name: el.name,
              title: el.position,
              bio: el.bio,
              linkedIn: el.linkedin_profile,
              twitter: el.twitter_profile
            })
          );
        })
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'part-of-fp' },
      _react2.default.createElement(
        'div',
        { className: 'wrapper' },
        _react2.default.createElement(
          'div',
          { className: 'col-1-2' },
          content.part_of.filter(function (el) {
            return el.component === 'Text';
          }).map(function (el) {
            return _react2.default.createElement(
              _storyblokReact2.default,
              { key: el._uid, content: el },
              _react2.default.createElement(
                'div',
                { className: 'heading--small' },
                el.text
              )
            );
          }),
          _react2.default.createElement('img', { className: 'part-of-fp__logo', src: _logo_fp_transparent2.default, alt: '' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-1-2 ' },
          content.part_of.map(function (el) {
            switch (el.component) {
              case 'Rich Text':
                return _react2.default.createElement(
                  _storyblokReact2.default,
                  { key: el._uid, content: el },
                  _react2.default.createElement('div', {
                    className: 'rich-text paragraph--sans',
                    dangerouslySetInnerHTML: {
                      __html: converter.makeHtml(el.markdown)
                    }
                  })
                );
              case 'Link':
                return _react2.default.createElement(
                  _storyblokReact2.default,
                  { key: el._uid, content: el },
                  _react2.default.createElement(
                    'a',
                    {
                      target: '_blank',
                      rel: 'noopener noreferrer',
                      href: el.link.cached_url,
                      className: 'button button--white part-of-fp__button'
                    },
                    el.label
                  )
                );
              default:
                return '';
            }
          })
        )
      )
    )
  );
};

exports.default = (0, _reactStatic.withRouteData)(About);

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/About.d72f2214.js